"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HTML = exports.TEXT = exports.URL = exports.FILE = void 0;
const FILE = '__NATIVE_FILE__';
exports.FILE = FILE;
const URL = '__NATIVE_URL__';
exports.URL = URL;
const TEXT = '__NATIVE_TEXT__';
exports.TEXT = TEXT;
const HTML = '__NATIVE_HTML__';
exports.HTML = HTML;

//# sourceMappingURL=NativeTypes.js.map